import { toastSlice } from './toast.slice';

export const toastReducer = toastSlice.reducer;
